import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import styles from './Collections.module.scss';
import Panel from '../../Panel';
import Collection from './Collection';
import actions from './actions';

export const Collections = (props) => {
  /*
    #TODO: This will be renamed to be Hunts
    -- WD - November 30, 2021
  */
  const feature = props.selectedFeature;
  const collections = props.collectionsList.filter((collection) =>
    feature.collectionIds.includes(collection.uuid)
  );

  return (
    <Panel
      title='Hunts'
      count={collections.length}
      collapsible={false}
    >
      <div className={styles.collectionsList}>
        {
          collections.map((collection, i) => {
            return (
              <Collection
                collection={collection}
                feature={props.selectedFeature}
                key={`${collection.uuid}-${i}`}
              />
            );
          })
        }
      </div>
    </Panel>
  );
};

Collections.propTypes = {
  collectionsList: PropTypes.array,
  selectedFeature: PropTypes.object
};

export default connect((model) => ({
  collectionsList: model.collections.collectionsList,
  selectedFeature: model.features.selectedFeature
}), actions)(Collections);